//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteCustomFieldUpdateItem } from './WebsiteCustomFieldUpdateItem';
import { WebsiteBlockType } from './Enums';

export class WebsiteCustomFieldContactFormUpdateItem extends WebsiteCustomFieldUpdateItem {
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.ContactForm;

    constructor(initializer?: Partial<Omit<WebsiteCustomFieldContactFormUpdateItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteCustomFieldContactFormUpdateItem";
}
